import React from 'react'
import type { Listing } from '~/models'

type ListingDescriptionProps = {
  listing: Listing
  heading?: React.ReactNode
}

export default function ListingDescription({
  listing,
  heading = null,
}: ListingDescriptionProps) {
  const description = listing.meta.description
  const highlights = listing.meta.highlights

  if (!description && !highlights) {
    return null
  }

  const prose = ((description || '') + (highlights || ''))
    .replace('<h4>Description</h4>', '')
    .replace('<h4>Highlights</h4>', '')
    .trim()

  if (!prose || prose == '<p></p>') {
    return null
  }

  return (
    <div>
      {heading}
      <div
        className="prose mt-1 max-w-none text-base"
        dangerouslySetInnerHTML={{ __html: prose }}></div>
    </div>
  )
}
